import React, { useEffect, useState } from "react";
import { BookOpen, TrendingUp, CreditCard, PiggyBank, Landmark, ShieldCheck, Wallet } from "lucide-react";
import api from "@/lib/api";
import { useSEO } from "@/hooks/useSEO";

const CAT_ICON = { "Demat & Trading": TrendingUp, Investing: PiggyBank, Credit: Landmark, Cards: CreditCard, Banking: PiggyBank, Loans: Landmark, Insurance: ShieldCheck, Wallet: Wallet };

export default function Knowledge() {
  useSEO({ title: "Knowledge & Guides", path: "/knowledge", description: "Learn about demat accounts, investing, credit cards, loans and insurance with simple guides from Credit Kendra. Make smarter money decisions.", keywords: "finance guides India, demat account guide, credit score, investing basics, loan tips" });
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return (
    <div className="max-w-[1280px] mx-auto px-6 py-14 min-h-[70vh]" data-testid="knowledge-page">
      <h1 className="font-display text-3xl lg:text-4xl font-extrabold text-[#0B223D] flex items-center gap-3"><BookOpen className="w-8 h-8 text-teal-500" /> Financial Knowledge</h1>
      <p className="text-slate-500 mt-2">Learn the essentials of demat, mutual funds, credit, loans and personal finance.</p>
      {loading ? (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">{[1, 2, 3].map((i) => <div key={i} className="h-44 rounded-2xl bg-slate-100 animate-pulse" />)}</div>
      ) : articles.length === 0 ? (
        <p className="text-slate-400 py-16 text-center">Articles jald aa rahe hain.</p>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {articles.map((a) => {
            const Icon = CAT_ICON[a.category] || BookOpen;
            return (
              <div key={a.id} className="bg-white rounded-2xl border border-slate-200 p-6 hover:shadow-lg transition-shadow" data-testid={`article-${a.id}`}>
                <div className="w-11 h-11 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center mb-4"><Icon className="w-5 h-5" /></div>
                <span className="text-[11px] font-bold uppercase tracking-wider text-emerald-brand">{a.category}</span>
                <h3 className="font-display font-bold text-lg text-[#0B223D] mt-1">{a.title}</h3>
                <p className="text-sm text-slate-500 mt-2 leading-relaxed whitespace-pre-line">{a.body}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
